// extracted by mini-css-extract-plugin
export var actionButton = "_bk-1";
export var actionButtons = "_bk-2";
export var actions = "_bk-0";
export var aiUnread = "_bk-10";
export var alignCenter = "_bk-h";
export var backWrapper = "_bk-3";
export var cellContainer = "_bk-4";
export var checkboxContainer = "_bk-5";
export var contentContainer = "_bk-6";
export var contentHeader = "_bk-8";
export var conversationsTableWrapper = "_bk-s";
export var draftReplyBadgeContainer = "_bk-m";
export var dropdownItem = "_bk-b";
export var dropdownItemsContainer = "_bk-a";
export var dropdownTitle = "_bk-c";
export var errorIcon = "_bk-7";
export var filter = "_bk-d";
export var gray = "_bk-i";
export var headerActionButtons = "_bk-e";
export var headerCheckboxContainer = "_bk-f";
export var icon = "_bk-j";
export var menuContainer = "_bk-k";
export var noMoreTicketsIcon = "_bk-12";
export var noMoreTicketsSubText = "_bk-13";
export var oneLine = "_bk-l";
export var optionsButton = "_bk-n";
export var plus = "_bk-o";
export var portalButtonsWrapper = "_bk-g";
export var red = "_bk-p";
export var scrolledTop = "_bk-9";
export var search = "_bk-q";
export var selectedConversationsCount = "_bk-r";
export var spinner = "_bk-t";
export var strong = "_bk-u";
export var summaryCell = "_bk-v";
export var tableContainer = "_bk-11";
export var tagContainer = "_bk-w";
export var threeDots = "_bk-x";
export var twoLines = "_bk-y";
export var unread = "_bk-z";